import { FormLabel } from '../../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Control, Controller } from 'react-hook-form';
import { Checkbox } from 'antd';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { useAppSelector } from 'store/hooks';
import { useMemo } from 'react';
import { SelectOption } from 'types/base';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';

const Accessory = ({
  control,
  index,
  required,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
  required?: boolean;
}) => {
  const { accessorySelectOptions } = useAppSelector(selectGlobalInfo);
  const accessoryListSort = useMemo((): SelectOption[] => {
    if (accessorySelectOptions && accessorySelectOptions.length) {
      return [...accessorySelectOptions].sort(
        (a: SelectOption, b: SelectOption) => b.sort! - a.sort!
      );
    }
    return [];
  }, [accessorySelectOptions]);

  return (
    <div className="flex items-center gap-2">
      <FormLabel className="self-start" required={required}>
        {i18n.t(LOCALS.accessories)}:
      </FormLabel>
      <Controller
        name={`productList.${index}.accessory`}
        control={control}
        render={({ field, formState: { errors } }) => (
          <div>
            <Checkbox.Group options={accessoryListSort} {...field} />
            {errors.productList?.[index]?.accessory && (
              <div className="text-red-500 text-sm mt-1">
                {errors.productList[index]?.accessory?.message}
              </div>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default Accessory;
